import { Component } from '@angular/core';
import { AccountService } from '../../../../services/account.service';
import { Subscription } from 'rxjs';
import { ITag } from '../../../../interfaces/graph-types';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalCreateCandidateTagComponent } from '../../../modals/create-candidate-tag/modal-create-candidate-tag.component';

@Component({
  selector: '[account-candidate-tags]',
  template: require('./account-candidate-tags.component.pug'),
  styles: [require('./account-candidate-tags.component.css').toString()],
})
export class AccountCandidateTagsComponent {
  private tags$: Subscription;
  tags: ITag[];

  bsModalRef: BsModalRef;
  subReason: Subscription = null;

  // -------------------------------------------------------------------
  constructor(
    private modalService: BsModalService,
    private accountService: AccountService,
    private watch: WatchAccountService,
  ) {}

  // -------------------------------------------------------------------
  trackByFn(index, item) {
    // https://medium.freecodecamp.org/best-practices-for-a-clean-and-performant-angular-application-288e7b39eb6f
    return item.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.tags$ = this.accountService
      .candidateTags(this.watch.accountId().getValue())
      .subscribe(tags => {
        this.tags = tags;
      });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.subReason) {
      this.subReason.unsubscribe();
    }
    if (this.tags$) {
      this.tags$.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  OpenCreateTagModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      org_id: 0, //response.organization.id,
    };

    this.bsModalRef = this.modalService.show(
      ModalCreateCandidateTagComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
  }
}
